import { InputHTMLAttributes } from 'react'
import Toggle from 'react-toggle'
import 'react-toggle/style.css'

import { Container, StyledToggleLabel } from './styles'

export interface ToggleProps extends InputHTMLAttributes<HTMLInputElement> {
  bgColor?: string
  borderColor?: string
  label?: string
  inputId?: string
}

function ToggleDrawer({
  checked,
  onChange,
  name,
  disabled,
  bgColor,
  borderColor,
  label,
  inputId,
}: ToggleProps) {
  const idInput = inputId || name
  return (
    <Container bgColor={bgColor} borderColor={borderColor}>
      <Toggle
        icons={false}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        id={idInput}
      />
      {label && (
        <StyledToggleLabel htmlFor={idInput}>{label}</StyledToggleLabel>
      )}
    </Container>
  )
}

export default ToggleDrawer
